export var OrgType;
(function (OrgType) {
    OrgType["Department"] = "1";
    OrgType["Role"] = "2";
    OrgType["User"] = "3"; // 用户
})(OrgType || (OrgType = {}));
